import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserLogin } from "./../../interfaces/UserLogin";
import API from "./../../services/API";
import { TokenService } from "./../../services/LocalStorage";
import { RootState } from "./../store";

interface IAuth {
  token: string;
  error: string;
  count: number;
}

const initialState: IAuth = {
  token: "-1",
  error: "",
  count: 0,
};

export const AuthStore = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state: { token: string }, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    logoutSuccess: (state: { token: string }) => {
      state.token = "-1";
    },
    setError: (state: { error: string }, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    increaseCounter: (state: { count: number }) => {
      state.count = state.count + 1;
    },
    resetCounter: (state: { count: number }) => {
      state.count = 0;
    },
  },
});

export const {
  loginSuccess,
  logoutSuccess,
  setError,
  increaseCounter,
  resetCounter,
} = AuthStore.actions;

export const selectUser = (state: RootState) => state.auth;

export const login = (user: UserLogin) => async (dispatch: any) => {
  try {
    API()
      .post(`security/gettoken`, user)
      .then((response) => {
        let data = response.data;
        if (data.Status === "Fail") {
          dispatch(setError("error"));
          dispatch(increaseCounter());
        } else {
          dispatch(resetCounter());
          TokenService.set(data.Token);
          dispatch(setError(""));
          dispatch(loginSuccess(data.Token));
        }
      });
  } catch (e: any) {
    dispatch(setError("error"));
    return console.error(e.message);
  }
};

export const checkToken = () => async (dispatch: any) => {
  try {
    API()
      .get(`security/checktoken?token=${TokenService.get()}`)
      .then((response) => {
        let data = response.data;
        if (data.Status === "Fail") {
          return dispatch(logoutSuccess());
        } else {
          dispatch(loginSuccess(data.Token));
        }
      });
  } catch (e: any) {
    dispatch(setError("error"));
    return console.error(e.message);
  }
};

export const logout = () => async (dispatch: any) => {
  try {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.clear();
      TokenService.remove();
      dispatch(setError(""));
      return dispatch(logoutSuccess());      
    } else {
      // dispatch(setError(""));
      // localStorage.clear();
      // TokenService.remove();
      const currentWindow: Window = window;
      currentWindow.close();
      // dispatch(setError(""));
      // return dispatch(logoutSuccess());
      // return true;
    }
  } catch (e: any) {
    return console.error(e.message);
  }
};

export default AuthStore.reducer;
